import React from 'react';
import { Dropdown } from 'antd';
import {PersonAddRounded, PlaylistAddRounded, PlaylistRemoveRounded} from "@mui/icons-material";
import Tooltip from "../../common/Tooltip";
import axios from "../../common/axios";

const ManageUsersDropdown = ({
                                classDetails,
                                handleAddStudent,
                                handleRefreshClasses,
                                addUserTooltipText = 'Add user',
                                usersClass = true,
                                renderTrigger = null,
                                placement = 'top'
                              }) => {
    const { className, classId } = classDetails;

    const handleAddRemoveClass = async () => {
        try {
            await axios.post('/web/ui/myClasses/updateTeacherClass', classId, {
                headers: {'Content-Type': 'application/json'}
            });
        } catch (error) {
            if (error.response?.data?.message) {
                displayToastMessage(error.response.data.message, error, 'error', undefined, 10000);
            } else {
                displayToastMessage('Unable to change class users. Try the action again.', error, 'error', undefined, 10000);
            }
        }
    };

    const handleMenuClick = ({ key }) => {
        if (key === 'manage') {
            handleAddStudent(classDetails);
        }
        if (key === 'join') {
            handleAddRemoveClass().then(() => {
                displayToastMessage(`You're now a teacher of ${className}`, null, 'success', undefined, 10000);
                handleRefreshClasses();
            })
        }
        if (key === 'leave') {
            handleAddRemoveClass().then(() => {
                displayToastMessage(`You're no longer a teacher of ${className}`, null, 'success', undefined, 10000);
                handleRefreshClasses();
            })
        }
    };

    const menuItems = [
        {
            key: 'manage',
            label: 'Edit class users',
            icon: <PersonAddRounded fontSize={'large'} />
        },
        {
            key: usersClass ? 'leave' : 'join',
            label: usersClass ? 'Remove class from My Classes' : 'Add class to My Classes',
            icon: usersClass ? <PlaylistRemoveRounded fontSize={'large'} /> : <PlaylistAddRounded fontSize={'large'} />
        },
    ];

    const defaultTrigger = (
        <Tooltip title={addUserTooltipText}>
            <button aria-label={'Add user'} data-gtm-value="classes-add-user"><PersonAddRounded /></button>
        </Tooltip>
    );

    return (
        <Dropdown
            menu={{ items: menuItems, onClick: handleMenuClick }}
            trigger={['click']}
            placement={placement}
        >
            {renderTrigger || defaultTrigger}
        </Dropdown>
    );
};

export default ManageUsersDropdown;